{
	"title": "View transactions",
	"aggregationInfo": "One transaction step on the Carbon Bank involves aggregating transactions on the distributed ledger. Below, you will find a list of links to third-party services where you can view these transactions.",
	"externalLinkDisclaimer": "Please note that these links will direct you to external websites that provide transaction viewing capabilities.",
	"tableHeaders": {
		"materialDescription": "Material",
		"quantity": "Quantity",
		"carbonReductions": "Carbon reductions",
		"transaction": "Transaction"
	},
	"closeTitle": "Close"
}
